import { Component, Prop, Vue } from "vue-property-decorator";
import { store } from "@/main";
import * as types from "@/store/constants/ins_user_info_types";
import ImgFetched from "@/components/ImgFetched/ImgFetched.vue";
@Component({
  components: {
    ImgFetched
  }
})
class BindVipConfirmHeader extends Vue {
  @Prop()
  private ctx: any;

  private userInfo: any = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
  public render() {
    return (
      <div
        class="header-top"
        style="width:100px;height:100px;border-radius:50%;background:rgb(247,248,250);padding:16px;margin:0 auto;position:relative"
      >
        <img-fetched
          style="width:100%;border-radius:50%;"
          src={this.userInfo.ins_user_info.profile_pic_url}
          alt=""
          imgKind="user"
        />
        <img
          style="width:108px;position:absolute;top:79px;left:50%;transform:translateX(-50%);"
          src={require("@/assets/icons-file/vip/picPaymentrConfirmaccount@3x.png")}
          alt=""
        />
      </div>
    );
  }
}
export default BindVipConfirmHeader;
